import * as d3 from 'd3'
export default {

  methods: {

    set_LocalValues(){
      // raw data
      this.chartData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))


      this.radio      = json.radio
      this.title      = json.title
      this.chart      = json.chart
      this.primary    = json.primary
      this.secondary  = json.secondary
      this.table      = json.table
      this.legends    = json.legends
      this.milestone  = json.milestone
      this.summary    = json.summary
      this.keys       = json.keys
      this.filters    = json.filters
      this.sundries   = json.sundries
      
      this.chartIdx   = json.chartIdx ? json.chartIdx : 1

      // set Current
      this.current = this.radio.list[0]
      if(this.getSelectItems) {
        this.getItems = JSON.parse(this.getSelectItems)
        this.current = this.getItems[`current${this.chartIdx}`] ? this.getItems[`current${this.chartIdx}`] : this.radio.list[0]
      }


      // Timeline
      this.timeline = json.timeline
      this.timeline.cutoff.date = this.Queries.SQL1[0].CUTOFF
      this.timeline.length = this.chart.width

      // Table
      this.table.height = this.chart.styles.filter(f=> f.tbl == 'Y').length * this.table.lineHeight

      // Summary
      if(Object.keys(this.summary).length > 0 && this.summary.apply == 'Y') {
        this.summary.dir.x = this.gmx_getCoordinates(this.summary.dir.width, this.summary.margin)
        this.summary.dir.item = [ ...new Set(this.summary.cols.map(d => d.group)) ]
      }
    },


    gmx_getCoordinates(arr, _x) {
      let convertArr = []
      let x = _x

      arr.forEach(d=> {
        convertArr.push({sx: x, mx: x + (d/2), ex: x + d})
        x += d
      })
      
      return convertArr
    },


  }
}